interface PaginationProps {
  page: number;
  total: number;
  perPage: number;
  loading?: boolean;
  /** Rótulo singular do recurso (ex.: "assunto"). Plural = `${label}s`. */
  label: string;
  /** Gênero do `label`, para concordar em "encontrado(a)(s)". Padrão: masculino. */
  gender?: 'm' | 'f';
  onPageChange: (page: number) => void;
}

/** Rodapé de paginação (contagem à esquerda, prev/next à direita). */
export function Pagination({
  page,
  total,
  perPage,
  loading,
  label,
  gender = 'm',
  onPageChange,
}: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));

  return (
    <div className="flex items-center justify-between">
      <p className="text-(--color-text-secondary) text-xs">
        {total} {total === 1 ? label : `${label}s`} encontrad
        {gender === 'f' ? 'a' : 'o'}
        {total !== 1 ? 's' : ''}
      </p>

      {totalPages > 1 && (
        <div className="flex items-center gap-2">
          <button
            onClick={() => onPageChange(Math.max(1, page - 1))}
            disabled={page === 1 || loading}
            className="border-(--color-border) text-(--color-text-secondary) hover:bg-(--color-bg-secondary) rounded-lg border px-3 py-1.5 text-xs transition-colors disabled:cursor-not-allowed disabled:opacity-40"
          >
            Anterior
          </button>
          <span className="text-(--color-text-secondary) text-xs">
            {page} de {totalPages}
          </span>
          <button
            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
            disabled={page === totalPages || loading}
            className="border-(--color-border) text-(--color-text-secondary) hover:bg-(--color-bg-secondary) rounded-lg border px-3 py-1.5 text-xs transition-colors disabled:cursor-not-allowed disabled:opacity-40"
          >
            Próxima
          </button>
        </div>
      )}
    </div>
  );
}
